import {
  COUNTERPART_TERM_OPPONENT,
  COUNTERPART_TERM_PARTNER,
  demandFromLossOffer,
  isLossFrame,
  lossOfferFromDemand,
  NEGOTIATION_TERM_DEMAND,
  NEGOTIATION_TERM_OFFER,
  normalizeCounterpartTerm,
  normalizeNegotiationTerm,
  normalizePayoffFrame,
  PAYOFF_FRAME_LOSS,
} from "../../shared/compensation.js";

export {
  COUNTERPART_TERM_OPPONENT,
  COUNTERPART_TERM_PARTNER,
  demandFromLossOffer,
  isLossFrame,
  lossOfferFromDemand,
  NEGOTIATION_TERM_DEMAND,
  NEGOTIATION_TERM_OFFER,
  normalizeCounterpartTerm,
  normalizeNegotiationTerm,
  normalizePayoffFrame,
  PAYOFF_FRAME_LOSS,
};

export function isLossFrameDesign(design) {
  return isLossFrame(design?.payoffFrame);
}

export function getNegotiationTerm(design) {
  return normalizeNegotiationTerm(design?.negotiationTerm);
}

// Accepts a game design or, before a game exists, the queued treatment.
export function getCounterpartTerm(design) {
  return normalizeCounterpartTerm(design?.counterpartTerm, design?.payoffFrame);
}

export function getCounterpartCopy(design) {
  const term = getCounterpartTerm(design);
  const isOpponent = term === COUNTERPART_TERM_OPPONENT;

  return {
    term,
    article: isOpponent ? "an" : "a",
    capitalizedTerm: isOpponent ? "Opponent" : "Partner",
  };
}

export function getNegotiationTermCopy(design) {
  const term = getNegotiationTerm(design);
  const counterpart = getCounterpartCopy(design);
  const isDemand = term === NEGOTIATION_TERM_DEMAND;
  const capitalizedTerm = isDemand ? "Demand" : "Offer";
  const pluralTerm = isDemand ? "demands" : "offers";
  const capitalizedPluralTerm = isDemand ? "Demands" : "Offers";

  return {
    term,
    article: isDemand ? "a" : "an",
    capitalizedTerm,
    pluralTerm,
    capitalizedPluralTerm,
    pastTense: isDemand ? "demanded" : "offered",
    gerund: isDemand ? "demanding" : "offering",
    savingsLabel: isDemand ? "Demanded Savings" : "Savings Offer",
    savingsPercentLabel: isDemand ? "Demanded savings" : "Savings offered",
    selectionTitle: isDemand
      ? "Click or drag to set demanded savings"
      : "Click or drag to set savings offer",
    yourLabel: `Your ${capitalizedTerm}`,
    yourWinningsLabel: isDemand ? "Your Demand" : "Your Requested Pay",
    counterpartLabel: `${counterpart.capitalizedTerm} ${capitalizedTerm}`,
  };
}
